export default (config) => {
  const {
    netlib,
    apiWrap,
  } = config;

  const getRoleBase = (accessToken) => apiWrap({
    apiQueryCb: async () => {
      const { data } = await netlib.RouteApi.getEcRolebase(accessToken, 'ENERGY_COMMUNITY_IT', {
        dashboard: 'CER_DASHBOARD',
      }, {
        apiDomain: '/services/rvxg',
      });

      return data?.externalPermissions;
    },
  });

  return {
    getRoleBase,
  };
};
